<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="374">
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <v-img
      height="250"
      src="https://cdn.vuetifyjs.com/images/cards/cooking.png"
    ></v-img>

    <v-card-title style="color:#B56476;">Tour Package Name</v-card-title>

    <v-divider class="mx-4"></v-divider>

      <div class="mx-4 subtitle-1">
        Departure Dates
      </div>
    <v-card-text>
      <v-chip-group
        v-model="selection"
        active-class="deep-purple accent-4 white--text"
        column
      >
        <v-chip>January 3</v-chip>
        <v-chip>August 5</v-chip>
      </v-chip-group>
    </v-card-text>

    <v-card-actions>
      <v-btn color="#F0807F" depressed style="color:#FEF9EF;" class="ml-2"  @click="reserve">
          Book Now
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {};
</script>